export const saleTypeOptions = [
  {
    value: "Goods at Standard Rate (default)",
    label: "Goods at Standard Rate (default)",
  },
  {
    value: "Steel Melting and re-rolling",
    label: "Steel Melting and re-rolling",
  },
  { value: "Ship breaking", label: "Ship breaking" },
  { value: "Goods at Reduced Rate", label: "Goods at Reduced Rate" },
  { value: "Exempt Goods", label: "Exempt Goods" },
  { value: "Goods at zero-rate", label: "Goods at zero-rate" },
  { value: "3rd Schedule Goods", label: "3rd Schedule Goods" },
  { value: "Cotton Ginners", label: "Cotton Ginners" },
  { value: "Telecommunication services", label: "Telecommunication services" },
  { value: "Toll Manufacturing", label: "Toll Manufacturing" },
  { value: "Petroleum Products", label: "Petroleum Products" },
  {
    value: "Electricity Supply to Retailers",
    label: "Electricity Supply to Retailers",
  },
  { value: "Gas to CNG stations", label: "Gas to CNG stations" },
  { value: "Mobile Phones", label: "Mobile Phones" },
  {
    value: "Processing / Conversion of Goods",
    label: "Processing / Conversion of Goods",
  },
  { value: "Goods (FED in ST Mode)", label: "Goods (FED in ST Mode)" },
  { value: "Services (FED in ST Mode)", label: "Services (FED in ST Mode)" },
  { value: "Services", label: "Services" },
  { value: "Electric Vehicle", label: "Electric Vehicle" },
  { value: "Cement / Concrete Block", label: "Cement / Concrete Block" },
  { value: "Potassium Chlorate", label: "Potassium Chlorate" },
  { value: "CNG Sales", label: "CNG Sales" },
  {
    value: "Goods as per SRO.297(I)/2023",
    label: "Goods as per SRO.297(I)/2023",
  },
  { value: "Non-Adjustable Supplies", label: "Non-Adjustable Supplies" },
];

export const saleTaxOptions = [
  { value: "0", label: "0%" },
  { value: "1", label: "1%" },
  { value: "5", label: "5%" },
  { value: "10", label: "10%" },
  { value: "15", label: "15%" },
  { value: "16", label: "16%" },
  { value: "17", label: "17%" },
  { value: "18", label: "18%" },
  { value: "25", label: "25%" },
];
